import { apiRequest } from './apiUtils';
import { SendMessageRequestDto, SendMessageResponseDto, SendFileMessageRequestDto, MarkConversationReadRequestDto, SetConversationArchivedRequestDto } from '@foodfluence/shared';

export const conversationApi = {
  /**
   * Campaign send. A missing thread is created server-side on an open invite for the collab's
   * creator. `influencerId` (X-Influencer-ID) names the creator when a superuser acts as one;
   * otherwise the backend derives the creator from the token.
   */
  sendMessage: async (params: SendMessageRequestDto, influencerId?: string): Promise<SendMessageResponseDto> => {
    return apiRequest({
      method: 'POST',
      endpoint: '/conversations/send-message',
      data: params,
      influencerId,
    });
  },

  /** Creator archive/unarchive of a campaign conversation (id = collab id). */
  setArchived: async (conversationId: string, archived: boolean, influencerId?: string): Promise<void> => {
    const data: SetConversationArchivedRequestDto = { archived };
    return apiRequest({
      method: 'PUT',
      endpoint: `/conversations/${encodeURIComponent(conversationId)}/archived`,
      data,
      influencerId,
    });
  },

  sendMarketplaceMessage: async (params: Omit<SendMessageRequestDto, 'isMarketplace'>, influencerId?: string): Promise<SendMessageResponseDto> => {
    return apiRequest({
      method: 'POST',
      endpoint: '/conversations/send-message',
      data: { ...params, isMarketplace: true },
      influencerId,
    });
  },

  sendMarketplaceFileMessage: async (params: SendFileMessageRequestDto, influencerId?: string): Promise<SendMessageResponseDto> => {
    return apiRequest({
      method: 'POST',
      endpoint: '/conversations/send-file',
      data: { ...params, isMarketplace: true },
      influencerId,
    });
  },

  markMarketplaceRead: async (params: MarkConversationReadRequestDto): Promise<void> => {
    return apiRequest({
      method: 'POST',
      endpoint: '/conversations/mark-read',
      data: { ...params, isMarketplace: true }
    });
  },
};
